import { default as api } from 'config/authApiConf.js';

export const listServiceApi = async (page = 1) => {
	try {
		let result = await api.get(`/cms/list-industry?page=${page}`);
		return result;
	} catch (error) {
		return error;
	}
};
